import React, { useState } from "react";
import { Typography, Button, CircularProgress, TextField, InputAdornment } from "@material-ui/core";
import {ReactComponent as UserIcon} from "../../assets/icons/userIcon.svg";
import classNames from "classnames";
import styles from "./styles";
import { color } from "three/examples/jsm/nodes/Nodes";
import { CenterFocusStrong } from "@material-ui/icons";

const VerifyOtpLayout = ({
  otp = "",
  loader = false,
  hostConfig = {},
  theme = {},
  onOtpChange = () => {},
  onVerifyOtp = () => {},
  onResendOtp = () => {},
  onBack = () => {},
}) => {
  const [otpFocus, setOtpFocus] = useState(false);
  const classes = styles();

  return (
    <>
      <form
        onSubmit={onVerifyOtp}
        style={{
          padding: "1em 2.5em 1em 2.5em ",
          fontFamily: "Ubuntu",
        }}
      >
        <Typography className={classes.label} style={{color: otpFocus && theme.palette.primary.main}}>Enter OTP</Typography>
        <TextField
          placeholder="Enter OTP"
          variant="outlined"
          value={otp}
          onChange={(e) => onOtpChange(e.target.value)}
          className={classes.input}
          required
          type={"text"}
          onFocus={() => setOtpFocus(true)}
          onBlur={() => setOtpFocus(false)}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                style={{
                  backgroundColor: "#FAFAFA",
                  border: "1px solid #E2E2E2",
                  height: 27,
                  width: 33,
                  borderRadius: 17,
                  marginLeft: -9,
                }}
              >
                <UserIcon stroke={otpFocus ? theme.palette.primary.main : ""} stroke-width="1" className={classes.fieldIcon} />
              </InputAdornment>
            ),
          }}
        />
    <Typography 
            style={{
              marginTop: "10px",
              color:"red",
              textAlign: "center",
            }}
          >
            The OTP is valid for 10 minutes
     </Typography>
        <Button
          className={classes.buttonSign}
          type="submit"
          variant="contained"
          style={{
            marginTop: "15%",
            backgroundColor: theme.palette.primary.main ? theme.palette.primary.main : "#39A8E0",
          }}
        >
          {loader ? (
            <>
              <CircularProgress
                color="#fff"
                size={16}
                style={{ marginLeft: 0 }}
              />{" "}
              Verify OTP
            </>
          ) : (
            "Verify OTP"
          )}
        </Button>
        <Button
          className={classes.buttonSign}
          variant="contained"
          style={{
            marginTop: "15px",
            backgroundColor: theme.palette.primary.main ? theme.palette.primary.main : "#39A8E0",
          }}
          onClick={onResendOtp}
        >
          Resend OTP
        </Button>
        <Button
          className={classNames(classes.buttonSign, "mt-4")}
          type="button"
          variant="outlined"
          onClick={onBack}
          style={{
            color: theme.palette.primary.main ? theme.palette.primary.main : "#39A8E0",
          }}
        >
          Sign In using Password
        </Button>
      </form>
    </>
  );
};

export default VerifyOtpLayout;
